goog.provide('el8.appchart.dialog.visitNoteTemplates');

goog.require('el8.uiwidget.ReactDialog');

el8.appchart.dialog.visitNoteTemplates = (function() {

    var that = new el8.uiwidget.ReactDialog({
        title: 'Visit Note Templates',
        autoHeight: true,
        reactComponentFn: function(id) {
            el8React.renderVNTDialog(id);
        },
        width: 410,
        reactProps: {},
        showXButton: true
    });
    return that;
})();
